import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../utils/constants';

// Fetch through Axios so the current bearer token is used; never put it in an image URL.
export default function PhotoAvatar({ photoUrl, name = '', className = 'h-12 w-12 rounded-xl', fallback, style }) {
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    if (!photoUrl || !/^\/(profile|groups)\/[^/?]+\/photo\?v=[a-z0-9-]+$/.test(photoUrl)) return;
    const controller = new AbortController(); let objectUrl;
    axios.get(`${API}${photoUrl}`, { responseType: 'blob', signal: controller.signal })
      .then(({ data }) => { if (controller.signal.aborted) return; objectUrl = URL.createObjectURL(data); setLoaded({ photoUrl, objectUrl }); })
      .catch(() => {});
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [photoUrl]);
  const src = loaded && loaded.photoUrl === photoUrl ? loaded.objectUrl : null;
  return <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden bg-gradient-to-br from-[#493986] to-[#92a7e8] text-white ${className}`} style={style}>
    {src ? <img src={src} alt={name ? `Photo of ${name}` : 'Photo'} className="h-full w-full object-cover" onError={() => setLoaded(null)} /> : fallback || <span aria-label={name ? `Initial of ${name}` : 'No photo'} className="font-bold">{name.charAt(0).toUpperCase() || 'U'}</span>}
  </span>;
}
